import { IntegrationSystem } from '@/shared/types';
import { RMPCServiceCode } from '@/shared/types/serviceCodes';

import { client } from '../../core/client';

import type { DataResponse } from '../../types';
import type {
  RmpcTattooDetailsResponse,
  RmpcTattooSearchBody,
  RmpcTattooSearchQueryParams,
  RmpcTattooSearchResponse,
  RmpcNestedDictionaryType,
  RmpcIntegration,
} from './types/types';

export const rmpc: RmpcIntegration = {
  dictionaries: {
    getTattooCategories: (): Promise<DataResponse<RmpcNestedDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMPC}/getTattooCategories`);
    },
    getTattooBodyLocations: (): Promise<DataResponse<RmpcNestedDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.RMPC}/getTattooBodyLocations`);
    },
  },
  getTattooSearch: (params: RmpcTattooSearchQueryParams): Promise<RmpcTattooSearchResponse> => {
    const searchParams = new URLSearchParams({
      page: params.page.toString(),
      per_page: params.per_page.toString(),
    });

    return client.get(`/user-requests/${RMPCServiceCode.TATTOO_SEARCH}/search?${searchParams.toString()}`);
  },
  postTattooSearch: (
    params: RmpcTattooSearchQueryParams,
    body: RmpcTattooSearchBody,
  ): Promise<RmpcTattooSearchResponse> => {
    const searchParams = new URLSearchParams({
      page: params.page.toString(),
      per_page: params.per_page.toString(),
    });

    return client.post(`/user-requests/${RMPCServiceCode.TATTOO_SEARCH}/search?${searchParams.toString()}`, body);
  },
  getTattooDetails: (number: string): Promise<RmpcTattooDetailsResponse> => {
    return client.get(`/user-requests/${RMPCServiceCode.TATTOO_SEARCH}/search/${number}`);
  },
};
